export const ONLINE_COLOR = '#6EF1D5';
export const FOLLOWING_COLOR = '#3FA5F0';
export const OFFLINE_COLOR = '#FE8FB6';
